import { LanguageOptions, StringObject } from '../../interfaces/components';

/* eslint-disable prettier/prettier */
export const makeDrawerItem = (scene: string, heading: string, subHeading: string) => {
  return {
    scene: scene,
    heading: heading,
    subHeading: subHeading,
  };
};

export const getOpSys = () => {
  let os = '';

  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'IOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (/Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
};

export const isValidUrl = (urlString: string) => {
  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // validate protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};

export const languageKeysArr: string[] = ['en', 'es', 'fr', 'it', 'ca', 'ko', 'zh', 'ar'];

export const languageNames: StringObject = {
  en: 'ENGLISH',
  es: 'ESPAÑOL',
  fr: 'FRANÇAIS',
  it: 'ITALIANO',
  ca: 'CATALÀ',
  ko: '한국어',
  zh: '中文',
  ar: 'اللغة العربية',
};

export const languageKeys: StringObject = {
  ENGLISH: 'en',
  ESPAÑOL: 'es',
  FRANÇAIS: 'fr',
  ITALIANO: 'it',
  CATALÀ: 'ca',
  한국어: 'ko',
  中文: 'zh',
  'اللغة العربية': 'ar',
};

export const languageOptions: LanguageOptions[] = [
  { name: 'ENGLISH', key: 'en' },
  { name: 'CATALÀ', key: 'ca' },
  { name: 'ESPAÑOL', key: 'es' },
  { name: 'ITALIANO', key: 'it' },
  { name: 'FRANÇAIS', key: 'fr' },
  { name: '한국어', key: 'ko' },
  { name: '中文', key: 'zh' },
  { name: 'اللغة العربية', key: 'ar' },
];

export const villagePrefixes: StringObject = {
  la_roca: 'lr',
  la_vallee: 'lv',
  bicester: 'bv',
  fidenza: 'fv',
};
